import axios from "axios";

const baseUrl =
  "https://www.principleacs.net/PACS_FieldTravelAllowance_RestApi_V2/public/";

export const get_employee_site_visits = async (empId, from_Date, to_Date) => {
  const obj = {
    empId: empId,
    fromDate: from_Date,
    toDate: to_Date,
  };
  const request = new URLSearchParams({
    emp_att_info: JSON.stringify(obj),
  }).toString();
  try {
    const res = await axios.post(`${baseUrl}getEmpAttendanceInfo`, request, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const get_all_employee_site_visits = async (fromDate, toDate) => {
  try {
    const response = await fetch(
      `https://your-api-endpoint.com/getAllEmpAttendance?fromDate=${fromDate}&toDate=${toDate}`
    );
    return await response.json();
  } catch (err) {
    console.error("Error fetching all employee data", err);
    return null;
  }
};

// import React from "react";
// import axios from "axios";

// const baseUrl =
//   "https://www.principleacs.net/PACS_FieldTravelAllowance_RestApi_V2/public/";

// export const get_employee_site_visits = async (empId, from_Date, to_Date) => {
//   const obj = {
//     empId: empId,
//     fromDate: from_Date,
//     toDate: to_Date,
//   };
//   const request = new URLSearchParams({
//     emp_att_info: JSON.stringify(obj),
//   }).toString();
//   try {
//     const res = await axios.post(`${baseUrl}getEmpAttendanceInfo`, request, {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     });
//     return res.data;
//   } catch (err) {
//     console.log(err);
//   }
// };

//---------------------------------------perfect -----------------------//

// import React from "react";
// import axios from "axios";

// const baseUrl =
//   "https://www.principleacs.net/PACS_FieldTravelAllowance_RestApi_V2/public/";

// export const get_employee_site_visits = async (empId, from_Date, to_Date) => {
//   const obj = {
//     empId: empId,
//     fromDate: from_Date,
//     toDate: to_Date,
//   };
//   const request = new URLSearchParams({
//     emp_att_info: JSON.stringify(obj),
//   }).toString();
//   try {
//     const res = await axios.post(`${baseUrl}getEmpAttendanceInfo`, request, {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     });
//     console.log(request);
//     console.log(res.data);
//     return res.data;
//   } catch (err) {
//     console.log(err);
//   }
// };
